import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  { path: 'app', loadChildren: () => import('./modules/main/main.module').then(m => m.MainModule), runGuardsAndResolvers: 'always' },
  { path: 'client', loadChildren: () => import('./modules/client/client.module').then(m => m.ClientModule), runGuardsAndResolvers: 'always' },
];
